import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.18 11.6948H12.7207L15.6222 14.6101C15.9028 14.8907 15.9028 15.3492 15.6222 15.6298C15.3417 15.9103 14.8832 15.9103 14.6026 15.6298L11.6942 12.7213V12.1807L11.5094 11.9891C10.5513 12.8103 9.24423 13.2346 7.85502 13.0019C5.95256 12.6803 4.43334 11.0926 4.20066 9.17646C3.84481 6.28172 6.28105 3.84548 9.17579 4.20133C11.0919 4.43401 12.6796 5.95324 13.0012 7.85569C13.2339 9.2449 12.8096 10.552 11.9884 11.5101L12.18 11.6948ZM5.53512 8.61531C5.53512 10.3193 6.91064 11.6948 8.61464 11.6948C10.3186 11.6948 11.6942 10.3193 11.6942 8.61531C11.6942 6.91131 10.3186 5.53579 8.61464 5.53579C6.91064 5.53579 5.53512 6.91131 5.53512 8.61531Z"
          fill="#A3B0CC"
        />
      </svg>
    </>
  );
};
